<template>
  <div>
    <!-- Layout TRIBANCO - Lado a lado -->
    <div id="lp2" class="banner-image" v-if="isTribanco">
      <div class="container">
        <div class="row justify-content-center align-items-stretch no-gutters">
          <div class="col-12 col-md-6 col-lg-5 px-0 mb-0 mb-md-0">
            <div class="tribanco-image-wrapper">
              <img
                class="img-fluid d-block w-100 tribanco-image"
                src="img/Banner Portal Tribanco.png"
                alt="Banner TRIBANCO"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 px-0">
            <div class="card bg-white shadow rounded tribanco-form-card h-100">
              <div class="card-body p-3 p-md-4">
                <h5
                  style="color: #054375; text-align: left; font-size: 18px"
                  class="mb-0 mt-3"
                >
                  Informe seus dados para começar:
                </h5>

                <form v-on:submit.prevent="doLogin" class="mt-4">
                  <AlertMessage v-bind:error="error" />

                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Seu CPF ou CNPJ"
                      id="form9"
                      :value="form.accessdoc"
                      required
                      @input="handleDocumentInput"
                      maxlength="18"
                    />
                  </div>

                  <div class="form-group mt-3 mb-3 position-relative">
                    <input
                      :type="isPasswordVisible ? 'text' : 'password'"
                      class="form-control pr-5"
                      placeholder="Código de acesso"
                      id="form10"
                      v-model="form.accesscode"
                      required
                    />

                    <div
                      style="
                        position: absolute;
                        top: 50%;
                        right: 10px;
                        transform: translateY(-50%);
                        z-index: 2;
                        cursor: pointer;
                      "
                    >
                      <PasswordToggleButton
                        :isPasswordVisible="isPasswordVisible"
                        @toggle-visibility="togglePasswordVisibility"
                      />
                    </div>
                  </div>

                  <small class="form-text">
                    <button
                      type="button"
                      class="mt-2"
                      @click="notCode()"
                      style="color: #054375; text-decoration: underline"
                    >
                      Quero receber o código
                    </button>
                  </small>

                  <button
                    v-if="!loading"
                    type="submit"
                    class="btn btn-lg mt-4 btn-primary text-white"
                  >
                    Acessar agora
                  </button>

                  <p class="small mt-3" style="color: #054375">
                    Ao acessar você aceita os
                    <router-link
                      :to="termosRoute"
                      class=""
                      style="text-decoration: underline; font-weight: 600"
                    >
                      termos de uso
                    </router-link>
                  </p>

                  <ProgressLoading v-bind:loading="loading" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout TRICARD - Original (centrado) -->
    <div
      id="lp2-tricard"
      class="d-flex flex-column align-items-center justify-content-center min-vh-100 banner-home-tricard"
      v-else
    >
      <div
        class="card mx-auto text-center tricard-login-card"
        style="max-width: 400px; width: 100%"
      >
        <h5
          style="color: #054375; text-align: left; font-size: 18px"
          class="mb-0 mt-3 px-3 tricard-login-title"
        >
          Informe seus dados para começar:
        </h5>

        <form v-on:submit.prevent="doLogin" class="px-3 tricard-login-form">
          <AlertMessage v-bind:error="error" />

          <div class="form-group mt-4">
            <input
              type="text"
              class="form-control"
              placeholder="Seu CPF ou CNPJ"
              id="form9"
              :value="form.accessdoc"
              required
              @input="handleDocumentInput"
              maxlength="18"
            />
          </div>

          <div class="form-group mt-3 mb-3 position-relative">
            <input
              :type="isPasswordVisible ? 'text' : 'password'"
              class="form-control pr-5"
              placeholder="Código de acesso"
              id="form10"
              v-model="form.accesscode"
              required
            />

            <div
              style="
                position: absolute;
                top: 50%;
                right: 10px;
                transform: translateY(-50%);
                z-index: 2;
                cursor: pointer;
              "
            >
              <PasswordToggleButton
                :isPasswordVisible="isPasswordVisible"
                @toggle-visibility="togglePasswordVisibility"
              />
            </div>
          </div>

          <small class="form-text">
            <button
              type="button"
              class="mt-2"
              @click="notCode()"
              style="color: #054375; text-decoration: underline"
            >
              Quero receber o código
            </button>
          </small>

          <button
            v-if="!loading"
            type="submit"
            class="btn btn-lg mt-4 btn-primary text-white tricard-login-submit"
          >
            Acessar agora
          </button>

          <p class="small mt-3 tricard-login-terms" style="color: #054375">
            Ao acessar você aceita os
            <router-link
              :to="termosRoute"
              class=""
              style="text-decoration: underline; font-weight: 600"
            >
              termos de uso
            </router-link>
          </p>

          <ProgressLoading v-bind:loading="loading" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, helpers } from "vuelidate/lib/validators";
import { validaCpfCnpj, ActionGetIPAddress, maskCpfCnpj } from "@/utils/helpers";
import { hasContacts, CONTACTS_NOT_FOUND_MESSAGE } from "@/utils/authContacts";
import AlertMessage from "./AlertMessage.vue";
import ProgressLoading from "./ProgressLoading.vue";
import { encryptTextWithKey, decryptHashWithKey } from "@/utils/crypto";
import PasswordToggleButton from "./PasswordToggleButton";

// Regex atualizado para suportar CNPJ alfanumérico (IN RFB nº 2.119/2022)
const regexaccessdoc = helpers.regex(
  "regexaccessdoc",
  /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$)/i
);

export default {
  components: {
    AlertMessage,
    ProgressLoading,
    PasswordToggleButton,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(14), regexaccessdoc },
    },
  },
  data: () => ({
    form: {
      accessdoc: null,
      accesscode: null,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    errors: false,
    loading: false,
    promoCode: null,
    sendCode: false,
    EmailOrPhone: "email",
    email: true,
    sms: false,
    code: false,
    emailDebtor: null,
    smsDebtor: null,
    infoDebtor: null,
    wwwurl: window.location.href,
    ipUser: null,
    isPasswordVisible: false,
    envOwnerId: process.env.VUE_APP_OWNER_ID,
  }),
  computed: {
    isTribanco() {
      const ownerId = this.envOwnerId;
      if (!ownerId) return false;
      
      if (Array.isArray(ownerId)) {
        return ownerId.map(Number).some((id) => [8, 22].includes(id));
      }
      
      return [8, 22].includes(Number(ownerId));
    },
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
    accessdocErrors() {
      const errors = [];
      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.minLength &&
        errors.push("Digite um CPF/CNPJ válido");
      !this.$v.form.accessdoc.required &&
        errors.push("CPF/CNPJ é obrigatório!");

      if (this.$v.form.accessdoc.length === 14) {
        !this.$v.form.accessdoc.regexaccessdoc &&
          errors.push("CPF não é válido");
      } else if (this.$v.form.accessdoc.length === 18) {
        !this.$v.form.accessdoc.regexaccessdoc &&
          errors.push("CNPJ não é válido");
      }

      return errors;
    },
    termosRoute() {
      const url = window.location.href;

      if (url.includes("https://negocie.tribanco.com.br")) {
        return "/termos_tribanco";
      } else {
        return "/termos_tricard";
      }
    },
  },
  methods: {
    ...mapActions("auth", [
      "ActionDoLogin",
      "ActionSetUser",
      "ActionGetContactsByDocNumber",
      "ActionSetCurrentForm",
      "ActionSetContacts",
    ]),

    invalidateForm() {
      this.errors = true;
    },
    showContactsNotFound(message = CONTACTS_NOT_FOUND_MESSAGE) {
      this.loading = false;
      this.error.status = "ERROR";
      this.accessdocErrors.push(message);
    },
    handleDocumentInput(event) {
      // Aplica máscara de CPF/CNPJ alfanumérico
      const maskedValue = maskCpfCnpj(event.target.value);
      this.form.accessdoc = maskedValue;
      event.target.value = maskedValue;
      this.saveDocument();
    },
    async getContacts() {
      this.loading = true;
      this.accessdocErrors.pop();
      this.$v.$touch();
      var isDocValid = validaCpfCnpj(this.form.accessdoc);

      if (this.$v.$invalid || !isDocValid) {
        this.loading = false;
        if (!isDocValid) {
          this.error.status = "ERROR";
          this.accessdocErrors.push("Informe um CPF/CNPJ válido.");
          this.loading = false;
        }
      } else {
        let accessdoc = this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase();

        try {
          let response = await this.ActionGetContactsByDocNumber({
            DocNumber: accessdoc,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });
          if (response.data.error) {
            this.loading = false;
            this.error.status = "ERROR";
            this.accessdocErrors.push(
              response.data.message
                ? response.data.message +
                    ". Entre em contato conosco através do nosso whatsapp"
                : "Não foi possível fazer login!"
            );
            return;
          }

          if (!hasContacts(response.data.results)) {
            this.showContactsNotFound();
            return;
          }

          if (response.data.results.SourceInfo == "API_EXTERNA") {
            this.ActionSetContacts({
              DocNumber: response.data.results.DocNumber,
              Emails: response.data.results.Emails,
              PhoneNumbers: response.data.results.MobileNumbers,
              ListEmailsWithMask: response.data.results.ListEmailsWithMask,
              ListPhonesWithMask: response.data.results.ListPhonesWithMask,
              SourceInfo: "API_EXTERNA",
            });
            this.loading = false;
            this.ActionSetCurrentForm("form-send-code");
          } else {
            this.loading = false;
            this.ActionSetContacts(response.data.results);
            this.ActionSetCurrentForm("form-promo-code");
          }
        } catch (error) {
          this.loading = false;
          this.accessdocErrors.push("Não foi possível fazer login!");
          this.error.status = "ERROR";
        }
      }
    },
    sendCodeForm() {
      this.ActionSetCurrentForm("form-send-code");
    },
    clear() {
      this.$v.$reset();
      this.form.accessdoc = "";
      this.form.termos = false;
    },

    async notCode() {
      this.loading = true;
      this.emailDebtor = null;
      this.smsDebtor = null;
      this.infoDebtor = null;

      if (this.form.accessdoc === null || this.form.accessdoc === "") {
        this.loading = false;
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Erro",
          message: "Informe um CPF",
        });
        return;
      }

      if (!this.sendCode) {
        await validaCpfCnpj(this.form.accessdoc);
        if (this.infoDebtor) {
          return;
        } else {
          let accessdoc = this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase();

          let response = await this.ActionGetContactsByDocNumber({
            DocNumber: accessdoc,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });
          if (response.data.error) {
            this.loading = false;
            this.error.status = "ERROR";
            this.accessdocErrors.push(
              response.data.message
                ? response.data.message +
                    ". Entre em contato conosco através do nosso whatsapp"
                : "Não foi possível fazer login!"
            );
            return;
          }

          if (!hasContacts(response.data.results)) {
            this.showContactsNotFound();
            return;
          }

          if (response.data.results.SourceInfo == "API_EXTERNA") {
            this.ActionSetContacts({
              DebtorID: response.data.results.DebtorID,
              DocNumber: response.data.results.DocNumber,
              Emails: response.data.results.Emails,
              PhoneNumbers: [
                response.data.results.PhoneNumbers,
                response.data.results.MobileNumbers,
              ],
              ListEmailsWithMask: response.data.results.ListEmailsWithMask,
              ListPhonesWithMask: response.data.results.ListPhonesWithMask,
              PhonesWithoutMask: response.data.results.PhonesWithoutMask,
              SourceInfo: "API_EXTERNA",
            });
            this.ActionSetCurrentForm("form-send-code"); // th
            this.loading = false;
          } else {
            this.ActionSetContacts({
              DebtorID: response.data.results.DebtorID,
              DocNumber: response.data.results.DocNumber,
              Emails: response.data.results.Emails,
              PhoneNumbers: [
                response.data.results.PhoneNumbers,
                response.data.results.MobileNumbers,
              ],
              ListEmailsWithMask: response.data.results.ListEmailsWithMask,
              ListPhonesWithMask: response.data.results.ListPhonesWithMask,
              PhonesWithoutMask: response.data.results.PhonesWithoutMask,
            });
            this.ActionSetCurrentForm("form-promo-code");
            this.loading = false;
          }
          this.sendCode = true;
          this.loading = false;
        }
      } else {
        this.sendCode = false;
        this.loading = false;
      }
    },

    async validateCpf() {
      this.loading = true;

      if (this.form.accessdoc === null || this.form.accessdoc === "") {
        this.loading = false;
        return;
      }

      var resp = await this.ActionGetContactsByDocNumber({
        DocNumber:
          this.form.accessdoc != null
            ? this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase()
            : "",
        OS: navigator.platform,
        IP: this.ipUser ? this.ipUser : "",
      });

      if (resp.status == 500 || resp.data?.error) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Nenhum usuário foi encontrado!",
        });
        this.loading = false;
        return;
      }

      if (!hasContacts(resp.data.results)) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: CONTACTS_NOT_FOUND_MESSAGE,
        });
        this.loading = false;
        return;
      }

      this.emailDebtor =
        resp.data.results.Emails.length > 0 ? resp.data.results.Emails[0] : "";
      this.smsDebtor =
        resp.data.results.PhoneNumbers.length > 0
          ? resp.data.results.PhoneNumbers[0]
          : "";
      this.infoDebtor = resp.data.results;

      this.ActionSetUser(resp.data.results);
      this.promoCode = resp.data.results.PromoCode;
      this.loading = false;
      this.thereIsCpf = true;
    },

    async doLogin() {
      if (this.form.accessdoc === null || this.form.accesscode === null) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Informe os dois campos!",
        });
        return;
      }

      this.loading = true;
      var accessdoc = this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase();
      let response = await this.ActionGetContactsByDocNumber({
        DocNumber: accessdoc,
        OS: navigator.platform,
        IP: this.ipUser ? this.ipUser : "",
      });

      if (response.data?.error) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: response.data.message || "Não foi possível fazer login!",
        });
        this.loading = false;
        return;
      }

      if (!hasContacts(response.data.results)) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: CONTACTS_NOT_FOUND_MESSAGE,
        });
        this.loading = false;
        return;
      }

      this.loading = true;
      // DebtorID pode não vir na resposta (Tribanco/Tricard não expõem mais esse campo
      // por segurança) — o backend resolve o devedor por DocNumber quando DebtorID faltar.
      let debtorId = response.data.results.DebtorID;
      let promoCode = this.form.accesscode;

      try {
        await this.ActionDoLogin({
          DebtorID: debtorId,
          DocNumber: accessdoc,
          PromoCode: promoCode,
          device_name: process.env.VUE_APP_API_DEVICE,
          IP: this.ipUser ? this.ipUser : "",
          OS: navigator.platform,
        });
        this.loading = false;

        localStorage.setItem(
          "authUser",
          JSON.stringify(this.$store.state.auth.user)
        );

        location.href = "/";
      } catch (error) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Ocorreu um erro",
          message: "Erro ao autenticar, promocode incorreto ou inválido",
        });
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },

    saveDocument() {
      window.localStorage.setItem("doc", this.form.accessdoc);
    },

    encryptData(doc) {
      const encryptedData = encryptTextWithKey(doc, "chave");
      return encryptedData;
    },

    decryptData(value, key) {
      const decryptedData = decryptHashWithKey(value, key);
      return decryptedData.trim();
    },

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          if (this.ipUser !== null) {
            localStorage.setItem("ipUser", this.ipUser);
          }
          break;
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },

  async created() {
    await this.getIPAddressUser();
    if (this.$route.query.cod) {
      var infoEncrypted = this.$route.query.cod;
      if (infoEncrypted !== null) {
        localStorage.setItem("infoEncrypted", infoEncrypted);
        this.ActionSetCurrentForm("fake-loading");
      } else {
        this.flashMessage.show({
          timeout: 300,
          status: "error",
          position: "top right",
          title: "Erro",
          message: "Ocorreu um erro.",
        });
        return;
      }
    }
  },
};
</script>

<style scoped>
@media (max-width: 500px) {
  .mainText {
    font-size: 22pt;
  }
}

@media (max-width: 500px) {
  .subText {
    font-size: 15pt;
  }
}

/* Layout TRIBANCO - Lado a lado */
.banner-image {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.tribanco-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: stretch;
  height: 100%;
}

.tribanco-image {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.tribanco-form-card {
  max-width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.tribanco-form-card .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Remove espaçamento entre imagem e card no desktop */
.row.no-gutters > [class*='col-'] {
  padding-right: 0;
  padding-left: 0;
}

@media (max-width: 768px) {
  .banner-image {
    background-position: top center;
    background-size: cover;
    padding: 20px 0;
  }
  
  .tribanco-image-wrapper {
    height: auto;
    margin-bottom: 0;
  }
  
  .tribanco-image {
    height: auto;
    object-fit: contain;
  }
  
  .tribanco-form-card {
    margin-top: 0;
  }
}

/* Layout TRICARD - Original (centrado) */
.banner-home-tricard {
  background-image: url('/img/banner-outubro-2025.jpg');
  background-size: cover;
  background-position: center;
  padding: 20px;
}

@media (max-width: 500px) {
  .banner-home-tricard {
    background-image: url('/img/banner-outubro-2025-mobile.jpg');
    background-position: top center;
    justify-content: flex-start;
    align-items: center;
    /* Espaço para não colar o card no fim do headline (navbar fixa ~64px fica por cima do viewport) */
    padding: calc(64px + env(safe-area-inset-top, 0px) + 6px) 10px 30px;
    min-height: 100dvh;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .banner-home-tricard .tricard-login-card {
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  .banner-home-tricard .tricard-login-title {
    font-size: 15px !important;
    margin-top: 0.4rem !important;
    padding-left: 0.65rem !important;
    padding-right: 0.65rem !important;
    line-height: 1.25;
  }

  .banner-home-tricard .tricard-login-form {
    padding-left: 0.65rem !important;
    padding-right: 0.65rem !important;
    padding-bottom: 0.35rem;
  }

  .banner-home-tricard .tricard-login-form .form-group.mt-4 {
    margin-top: 0.65rem !important;
  }

  .banner-home-tricard .tricard-login-form .form-group.mt-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .banner-home-tricard .tricard-login-form .form-control {
    padding: 0.35rem 0.6rem;
    font-size: 16px;
  }

  .banner-home-tricard .tricard-login-form .form-text button.mt-2 {
    margin-top: 0.25rem !important;
    font-size: 0.8rem;
  }

  .banner-home-tricard .tricard-login-submit {
    margin-top: 0.7rem !important;
    padding: 0.5rem 0.85rem !important;
    font-size: 0.95rem !important;
    line-height: 1.2;
    width: 100%;
  }

  .banner-home-tricard .tricard-login-submit.btn-lg {
    border-radius: 6px;
  }

  .banner-home-tricard .tricard-login-terms {
    margin-top: 0.45rem !important;
    margin-bottom: 0.25rem;
    font-size: 0.72rem;
    line-height: 1.3;
  }
}
</style>